import { render, staticRenderFns } from "./GetApp.vue?vue&type=template&id=77b0ba70"
import script from "./GetApp.vue?vue&type=script&lang=js"
export * from "./GetApp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports